import { TFnType } from '@tolgee/react'

interface AccumulatorContainerInfo {
  containerNumber?: string
}

export const formatAccumulatorPrimary = (
  info: AccumulatorContainerInfo | undefined,
  id: number,
  t: TFnType,
): string => info?.containerNumber ?? t('containerWithId', 'Container #{id}', { id })
